module.exports = __webpack_public_path__ + "img/logo_fc_img.9c7b5c9e.png";